<ion-card
  [class.desktop]="platform === platformRef.desktop"
  [class.tablet]="platform === platformRef.tablet"
  [class.mobile]="platform === platformRef.mobile"
  (click)="onCardClick($event, supportItem)"
>
  <ng-container
    *ngIf="platform === platformRef.desktop"
    [ngTemplateOutlet]="desktopCard"
  >
  </ng-container>
  <ng-container
    *ngIf="platform === platformRef.mobile"
    [ngTemplateOutlet]="mobileCard"
  >
  </ng-container>
  <ng-container
    *ngIf="platform === platformRef.tablet"
    [ngTemplateOutlet]="tabletCard"
  >
  </ng-container>
</ion-card>

<ng-template #desktopCard>
  <ion-row>
    <ion-col size="0.1">
      <ng-container [ngTemplateOutlet]="statusColor"> </ng-container>
    </ion-col>
    <ion-col size="1.65" offset="0.125">
      <ng-container [ngTemplateOutlet]="productImageAndNum"> </ng-container>
    </ion-col>
    <ion-col offset="0.18" size="1.9">
      <ng-container [ngTemplateOutlet]="requestNum"> </ng-container>
    </ion-col>
    <ion-col offset="0.18" size="1.266">
      <ng-container [ngTemplateOutlet]="status"> </ng-container>
    </ion-col>
    <ion-col offset="0.18" size="1">
      <ng-container [ngTemplateOutlet]="invoiceNum"> </ng-container>
    </ion-col>
    <ion-col offset="0.18" size="0.75">
      <ng-container [ngTemplateOutlet]="orderNum"> </ng-container>
    </ion-col>
    <ion-col offset="0.18" size="0.75">
      <ng-container [ngTemplateOutlet]="dateNum"> </ng-container>
    </ion-col>
    <ion-col
      offset="0.18"
      size="2.75"
      *ngIf="
        !!supportItem.caseNumber ||
        statusRef.FAILED !== supportItem.status ||
        !!supportItem.isResubmitting
      "
    >
      <ng-container [ngTemplateOutlet]="userName"> </ng-container>
    </ion-col>
    <ion-col
      offset="0.18"
      size="2.25"
      *ngIf="
        !supportItem.caseNumber &&
        statusRef.FAILED === supportItem.status &&
        !supportItem.isResubmitting
      "
    >
      <ng-container [ngTemplateOutlet]="userNameShort"> </ng-container>
    </ion-col>
    <ion-col
      [size]="
        !supportItem.caseNumber && statusRef.FAILED === supportItem.status
          ? 0.75
          : 0.55
      "
      [offset]="
        !supportItem.caseNumber && statusRef.FAILED === supportItem.status
          ? 0.18
          : 0
      "
      *ngIf="
        ((!supportItem.caseNumber && statusRef.FAILED === supportItem.status) ||
          !supportItem.isMoxeOriginated) &&
        !supportItem.isResubmitting
      "
    >
      <ng-container [ngTemplateOutlet]="interaction"> </ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #tabletCard>
  <ion-row>
    <ion-col size="0.1">
      <ng-container [ngTemplateOutlet]="statusColor"> </ng-container>
    </ion-col>
    <ion-col size="2" offset="0.2">
      <ng-container [ngTemplateOutlet]="productImageAndNum"> </ng-container>
    </ion-col>
    <ion-col offset="0.4" size="3.5">
      <ng-container [ngTemplateOutlet]="requestNum"> </ng-container>
    </ion-col>
    <ion-col offset="0.5" size="1.5">
      <ng-container [ngTemplateOutlet]="status"> </ng-container>
    </ion-col>
    <ion-col offset="0.5" size="1">
      <ng-container [ngTemplateOutlet]="invoiceNum"> </ng-container>
    </ion-col>
    <ion-col
      offset="0.5"
      size="1.8"
      *ngIf="
        ((!supportItem.caseNumber && statusRef.FAILED === supportItem.status) ||
          !supportItem.isMoxeOriginated) &&
        !supportItem.isResubmitting
      "
    >
      <ng-container [ngTemplateOutlet]="interaction"> </ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #mobileCard>
  <ion-row class="big">
    <ion-col size="0.25">
      <ng-container [ngTemplateOutlet]="statusColor"> </ng-container>
    </ion-col>
    <ion-col size="11.5" offset="0.25">
      <ion-row class="bit-of-margin">
        <ion-col size="2">
          <ng-container [ngTemplateOutlet]="productImage"> </ng-container>
        </ion-col>
        <ion-col size="9.5" offset="0.5">
          <ion-row>
            <ion-col size="8">
              <ng-container [ngTemplateOutlet]="requestNum"> </ng-container>
            </ion-col>
            <ion-col
              [size]="!supportItem.caseNumber ? 3.5 : 1.5"
              [offset]="!supportItem.caseNumber ? 0.5 : 2.5"
              *ngIf="
                ((!supportItem.caseNumber &&
                  statusRef.FAILED === supportItem.status) ||
                  !supportItem.isMoxeOriginated) &&
                !supportItem.isResubmitting
              "
            >
              <ng-container [ngTemplateOutlet]="interaction"> </ng-container>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <ng-container [ngTemplateOutlet]="status"> </ng-container>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>

      <ion-row class="bit-more-margin set-height">
        <ion-col size="5">
          <ng-container [ngTemplateOutlet]="prodNumMobile"> </ng-container
        ></ion-col>
        <ion-col size="6" offset="0.5">
          <ng-container [ngTemplateOutlet]="dateNumMobile"> </ng-container
        ></ion-col>
      </ion-row>

      <ion-row class="set-height">
        <ion-col size="5">
          <ng-container [ngTemplateOutlet]="invoiceNumMobile"> </ng-container
        ></ion-col>
        <ion-col size="6" offset="0.5">
          <ng-container [ngTemplateOutlet]="userNameMobileTop"> </ng-container
        ></ion-col>
      </ion-row>

      <ion-row class="set-height">
        <ion-col size="5">
          <ng-container [ngTemplateOutlet]="orderNumMobile"> </ng-container
        ></ion-col>
        <ion-col size="6" offset="0.5">
          <ng-container [ngTemplateOutlet]="userNameMobileBot"> </ng-container>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #productImageAndNum>
  <app-product-card-image
    [imageThumbnail]="supportItem.productImageUrl"
    [productNumber]="supportItem.productNumber"
    [isOnline]="true"
    [isMedium]="true"
  >
  </app-product-card-image>
  <p [attr.data-cy]="'product-num-support-' + index" class="nudge-to-right">
    {{
      !!supportItem.productNumber
        ? '#' + (supportItem.productNumber + '' | truncateWithEllipsis: 10)
        : 'N/A'
    }}
  </p>
</ng-template>

<ng-template #productImage>
  <app-product-card-image
    [imageThumbnail]="supportItem.productImageUrl"
    [productNumber]="supportItem.productNumber"
    [isOnline]="true"
    [isSmall]="true"
  >
  </app-product-card-image>
</ng-template>

<ng-template #requestNum>
  <p [attr.data-cy]="'request-num-support-' + index">
    <span
      class="bold"
      *ngIf="supportItem.serviceRequestType === requestRef.PICKUP_REQUEST"
      >{{ 'i18n.supportCenter.request.pickup' | translate }}</span
    >
    <span
      class="bold"
      *ngIf="supportItem.serviceRequestType === requestRef.RECOVERY_REQUEST"
      >{{ 'i18n.supportCenter.request.recovery' | translate }}</span
    >
    <span
      class="bold"
      *ngIf="supportItem.serviceRequestType === requestRef.REQUEST_CREDIT"
      >{{ 'i18n.supportCenter.request.credit' | translate }}</span
    >
    <span
      class="bold"
      *ngIf="supportItem.serviceRequestType === requestRef.SUPPORT_REQUEST"
      >{{ 'i18n.supportCenter.request.support' | translate }}</span
    >
    <span *ngIf="!!supportItem.caseNumber"> #{{ supportItem.caseNumber }}</span>
  </p>
</ng-template>

<ng-template #status>
  <app-support-center-status
    class="center-me"
    [status]="supportItem.status"
    [statusText]="supportItem.statusText"
    [serviceRequestType]="supportItem.serviceRequestType"
    [isResubmitting]="supportItem.isResubmitting"
    [platform]="platform"
    [isCard]="true"
  >
  </app-support-center-status>
</ng-template>

<ng-template #invoiceNum>
  <p *ngIf="!!supportItem.invoiceNumber">
    {{ supportItem.invoiceNumber | truncateWithEllipsis: 10 }}
  </p>
  <p *ngIf="!supportItem.invoiceNumber">
    {{ 'N/A' }}
  </p>
</ng-template>

<ng-template #orderNum>
  <p *ngIf="!!supportItem.orderNumber">
    {{ supportItem.orderNumber | truncateWithEllipsis: 10 }}
  </p>
  <p *ngIf="!supportItem.orderNumber">
    {{ 'N/A' }}
  </p>
</ng-template>

<ng-template #dateNum>
  <p *ngIf="!!supportItem.submissionDate">
    {{ supportItem.submissionDate | date: 'M/d/yy' }}
  </p>
  <p *ngIf="!supportItem.submissionDate">N/A</p>
</ng-template>

<ng-template #userName>
  <p
    *ngIf="
      !!supportItem.submittedByUser.firstName ||
      !!supportItem.submittedByUser.lastName ||
      !!supportItem.submittedByUser.userName
    "
  >
    {{
      (supportItem.submittedByUser.firstName ?? '') +
        ' ' +
        (supportItem.submittedByUser.lastName ?? '') +
        (!!supportItem.submittedByUser.userName ? ' (' : '') +
        (supportItem.submittedByUser.userName ?? '') +
        (!!supportItem.submittedByUser.userName ? ')' : '')
        | truncateWithEllipsis: 30
    }}
  </p>
  <p
    *ngIf="
      !supportItem.submittedByUser.firstName &&
      !supportItem.submittedByUser.lastName &&
      !supportItem.submittedByUser.userName
    "
  >
    System
  </p>
</ng-template>

<ng-template #userNameShort>
  <p
    *ngIf="
      !!supportItem.submittedByUser.firstName ||
      !!supportItem.submittedByUser.lastName ||
      !!supportItem.submittedByUser.userName
    "
  >
    {{
      (supportItem.submittedByUser.firstName ?? '') +
        ' ' +
        (supportItem.submittedByUser.lastName ?? '') +
        (!!supportItem.submittedByUser.userName ? ' (' : '') +
        (supportItem.submittedByUser.userName ?? '') +
        (!!supportItem.submittedByUser.userName ? ')' : '')
        | truncateWithEllipsis: 20
    }}
  </p>
  <p
    *ngIf="
      !supportItem.submittedByUser.firstName &&
      !supportItem.submittedByUser.lastName &&
      !supportItem.submittedByUser.userName
    "
  >
    System
  </p>
</ng-template>

<ng-template #interaction>
  <!-- resubmit has priority -->
  <p
    class="resub"
    (click)="onResubmitClick($event)"
    *ngIf="!supportItem.caseNumber && statusRef.FAILED === supportItem.status"
    [attr.data-cy]="'re-submit-support-click-' + index"
  >
    {{ 'i18n.common.resubmit' | translate }}
  </p>
  <ion-icon
    *ngIf="!!supportItem.caseNumber"
    (click)="popoverInteraction($event, true)"
    name="information-circle"
    class="info-icon"
    [attr.data-cy]="'information-support-click-' + index"
  >
  </ion-icon>
</ng-template>

<ng-template #statusColor>
  <div
    *ngIf="!supportItem.isResubmitting"
    class="fill"
    [class.fail]="statusRef.FAILED === supportItem.status"
    [class.orange]="
      (statusRef.NEW === supportItem.status &&
        supportItem.serviceRequestType !== requestRef.SUPPORT_REQUEST) ||
      statusRef.CREATED === supportItem.status ||
      statusRef.PENDING_CDMR_DECISION === supportItem.status ||
      statusRef.IN_PROGRESS === supportItem.status
    "
    [class.approve]="statusRef.APPROVED === supportItem.status"
    [class.close]="statusRef.CLOSED === supportItem.status"
  ></div>
  <div *ngIf="!!supportItem.isResubmitting" class="fill resubmit"></div>
</ng-template>

<ng-template #invoiceNumMobile>
  <p *ngIf="!!supportItem.invoiceNumber">
    {{
      ('i18n.supportCenter.card.invoice' | translate) +
        (supportItem.invoiceNumber | truncateWithEllipsis: 10)
    }}
  </p>
  <p *ngIf="!supportItem.invoiceNumber">
    {{ ('i18n.supportCenter.card.invoice' | translate) + 'N/A' }}
  </p>
</ng-template>

<ng-template #orderNumMobile>
  <p *ngIf="!!supportItem.orderNumber">
    {{
      ('i18n.supportCenter.card.order' | translate) +
        (supportItem.orderNumber | truncateWithEllipsis: 10)
    }}
  </p>
  <p *ngIf="!supportItem.orderNumber">
    {{ ('i18n.supportCenter.card.order' | translate) + 'N/A' }}
  </p>
</ng-template>

<ng-template #dateNumMobile>
  <p *ngIf="!!supportItem.submissionDate">
    {{
      ('i18n.supportCenter.card.date' | translate) +
        (supportItem.submissionDate | date: 'M/d/yy')
    }}
  </p>
  <p *ngIf="!supportItem.submissionDate">
    {{ 'i18n.supportCenter.card.date' | translate }} N/A
  </p>
</ng-template>

<ng-template #prodNumMobile>
  <p *ngIf="!!supportItem.productNumber">
    {{
      ('i18n.supportCenter.card.product' | translate) +
        ('' + supportItem.productNumber | truncateWithEllipsis: 10)
    }}
  </p>
  <p *ngIf="!supportItem.productNumber">
    {{ 'i18n.supportCenter.card.product' | translate }} N/A
  </p>
</ng-template>

<ng-template #userNameMobileTop>
  <p *ngIf="!!supportItem.submittedByUser.firstName">
    {{
      ('i18n.supportCenter.card.user' | translate) +
        supportItem.submittedByUser.firstName ?? ''
    }}
  </p>
  <p
    *ngIf="
      !supportItem.submittedByUser.firstName &&
      (!!supportItem.submittedByUser.lastName ||
        !!supportItem.submittedByUser.userName)
    "
  >
    {{ 'i18n.supportCenter.card.user' | translate }}
  </p>
  <p
    *ngIf="
      !supportItem.submittedByUser.firstName &&
      !supportItem.submittedByUser.lastName &&
      !supportItem.submittedByUser.userName
    "
  >
    {{ 'i18n.supportCenter.card.user' | translate }}System
  </p>
</ng-template>

<ng-template #userNameMobileBot>
  <p
    *ngIf="
      !!supportItem.submittedByUser.lastName ||
      !!supportItem.submittedByUser.userName
    "
  >
    {{
      (supportItem.submittedByUser.lastName ?? '') +
        (!!supportItem.submittedByUser.userName ? ' (' : '') +
        (supportItem.submittedByUser.userName ?? '') +
        (!!supportItem.submittedByUser.userName ? ')' : '')
        | truncateWithEllipsis: 20
    }}
  </p>
</ng-template>

<ion-popover
  data-cy="support-center-popover"
  class="support-center-popover"
  #supportCenterPopover
  mode="ios"
  showBackdrop="false"
  [isOpen]="openPopover"
  (didDissmess)="popoverInteraction(undefined, false)"
>
  <ng-template>
    <app-support-center-popover></app-support-center-popover>
  </ng-template>
</ion-popover>
